module.exports = __webpack_public_path__ + "static/media/attempt-coin.5f3854aa.svg";